import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "building-setting";

const GET_BUILDING_SETTING_OPTION_URL = `${prefix}/get-option`;
const GET_ALL_BUILDING_URL = `${prefix}/all-building`;
const GET_ALL_FLOOR_URL = `${prefix}/all-floor`;
const GET_ALL_ROOM_URL = `${prefix}/all-room`;
const GET_ALL_ROOM_DOCTOR_URL = `${prefix}/all-room-doctor`;
const CREATE_BUILDING_URL = `${prefix}/create-building`;
const CREATE_FLOOR_URL = `${prefix}/create-floor`;
const CREATE_ROOM_URL = `${prefix}/create-room`;
const UPDATE_BUILDING_BY_ID_URL = `${prefix}/update-building-by-id`;
const UPDATE_FLOOR_BY_ID_URL = `${prefix}/update-floor-by-id`;
const UPDATE_ROOM_BY_ID_URL = `${prefix}/update-room-by-id`;
const DELETE_BUILDING_BY_ID_URL = `${prefix}/delete-building-by-id`;
const DELETE_FLOOR_BY_ID_URL = `${prefix}/delete-floor-by-id`;
const DELETE_ROOM_BY_ID_URL = `${prefix}/delete-room-by-id`;

/**
 * @func getBuildingSettingOption
 * @desc get building setting option
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} building setiing option
 */
export const getBuildingSettingOption = async signal => {
    try {
        const { data, status } = await axios.get(GET_BUILDING_SETTING_OPTION_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getBuildingSettingOption");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getBuildingSettingOption */

/**
 * @func getAllBuilding
 * @desc get all building data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} building array
 */
export const getAllBuilding = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_BUILDING_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllBuilding");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllBuilding */

/**
 * @func getAllFloor
 * @desc get all floor data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} floor array
 */
export const getAllFloor = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_FLOOR_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllFloor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllFloor */

/**
 * @func getAllRoom
 * @desc get all room data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} room array
 */
export const getAllRoom = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_ROOM_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllRoom");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllRoom */

/**
 * @func getAllRoomDoctor
 * @desc get all room data
 * @author jew
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} room array
 */
export const getAllRoomDoctor = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_ROOM_DOCTOR_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllRoomDoctor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllRoomDoctor */

/**
 * @func createBuilding
 * @desc create new building
 * @author izeberg
 * @param {Object} body - create building body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const createBuilding = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_BUILDING_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createBuilding");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createBuilding */

/**
 * @func createFloor
 * @desc create new floor
 * @author izeberg
 * @param {Object} body - create floor body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const createFloor = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_FLOOR_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createFloor");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createFloor */

/**
 * @func createRoom
 * @desc create new room
 * @author izeberg
 * @param {Object} body - create room body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} create status
 */
export const createRoom = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_ROOM_URL, body, { signal });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createRoom");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createRoom */

/**
 * @func updateBuildingById
 * @desc update building by id
 * @author izeberg
 * @param {number} id - building id
 * @param {Object} body - update building body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateBuildingById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_BUILDING_BY_ID_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateBuildingById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateBuildingById */

/**
 * @func updateFloorById
 * @desc update floor by id
 * @author izeberg
 * @param {number} id - floor id
 * @param {Object} body - update floor body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateFloorById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_FLOOR_BY_ID_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateFloorById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateFloorById */

/**
 * @func updateRoomById
 * @desc update room by id
 * @author izeberg
 * @param {number} id - room id
 * @param {Object} body - update room body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} update status
 */
export const updateRoomById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_ROOM_BY_ID_URL}/${id}`, body, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateRoomById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateRoomById */

/**
 * @func deleteBuildingById
 * @desc delete building by id
 * @author izeberg
 * @param {number} id - building id
 * @param {Object} body - delete building body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} delete status
 */
export const deleteBuildingById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_BUILDING_BY_ID_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteBuildingById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteBuildingById */

/**
 * @func deleteFloorById
 * @desc delete floor by id
 * @author izeberg
 * @param {number} id - floor id
 * @param {Object} body - delete floor body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} delete status
 */
export const deleteFloorById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_FLOOR_BY_ID_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteFloorById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteFloorById */

/**
 * @func deleteRoomById
 * @desc delete room by id
 * @author izeberg
 * @param {number} id - room id
 * @param {Object} body - delete room body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean|undefined} delete status
 */
export const deleteRoomById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_ROOM_BY_ID_URL}/${id}`, { signal });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteRoomById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteRoomById */
